import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import { CoachingUserType } from 'globalTypes';
import GET_COACHING_SESSIONS_QUERY from 'coaching/queries/GetCoachingSessionsAndRecordings.gql';
import {
  GetCoachingSessionsAndRecordings,
  GetCoachingSessionsAndRecordings_coaching_getPreviousSessions,
  GetCoachingSessionsAndRecordings_coaching_getUpcomingSessions,
  GetCoachingSessionsAndRecordings_coaching_getUpcomingSessions_instances,
  GetCoachingSessionsAndRecordings_coaching_getPreviousSessions_instances,
  GetCoachingSessionsAndRecordings_distanceLearning_distanceLearningSessionMedia_media,
} from 'coaching/queries/__generated__/GetCoachingSessionsAndRecordings';

export type CoachingSessionGQL =
  | GetCoachingSessionsAndRecordings_coaching_getPreviousSessions
  | GetCoachingSessionsAndRecordings_coaching_getUpcomingSessions;

export type CoachingInstanceGQL =
  | GetCoachingSessionsAndRecordings_coaching_getUpcomingSessions_instances
  | GetCoachingSessionsAndRecordings_coaching_getPreviousSessions_instances;

export type DistanceLearningSessionGQL = GetCoachingSessionsAndRecordings_distanceLearning_distanceLearningSessionMedia_media;

export type Props = {
  participantUuid: string;
  userType: CoachingUserType;
  distanceLearningSessionUuid: string;
  children: (props: {
    upcomingSessions?: CoachingSessionGQL[];
    previousSessions?: CoachingSessionGQL[];
    sessionMedia?: DistanceLearningSessionGQL[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCoachingSessionsAndRecordingsContainer(props: Props) {
  return (
    <Query<GetCoachingSessionsAndRecordings>
      query={GET_COACHING_SESSIONS_QUERY}
      variables={{
        userUuid: props.participantUuid,
        userType: props.userType,
        distanceLearningSessionUuid: props.distanceLearningSessionUuid,
      }}>
      {({ loading, error, data }) => {
        return props.children({
          upcomingSessions: data?.coaching_getUpcomingSessions,
          previousSessions: data?.coaching_getPreviousSessions,
          sessionMedia: data?.distanceLearning?.distanceLearningSessionMedia?.media ?? undefined,
          loading,
          error,
        });
      }}
    </Query>
  );
}
